import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngxs/store';
import { GetComponentCopyStatus } from 'src/app/maintenance-admin/state/components-structure.actions';
import { ComponentsStructureState } from 'src/app/maintenance-admin/state/components-structure.state';
import { ComponentCopyStatus } from 'src/app/maintenance-admin/models/components-structure-menu.model';

@Component({
  selector: 'app-copy-status-modal',
  templateUrl: './copy-status-modal.component.html',
  styleUrls: ['./copy-status-modal.component.scss'],
  standalone: false,
})
export class CopyStatusModalComponent implements OnInit {
  copyStatus = select(ComponentsStructureState.getComponentCopyStatus);

  constructor(
    public dialogRef: MatDialogRef<CopyStatusModalComponent>,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new GetComponentCopyStatus());
  }

  close(): void {
    this.dialogRef.close();
  }
}
